module.exports = __webpack_public_path__ + "img/guide18.d112a00a.jpg";